import React, { useState, useEffect, useRef } from "react";
import Select from "../../ui/PortalSelect";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import "antd/dist/antd.css";
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import { DeleteSweepTwoTone } from "@mui/icons-material";
import { loadAccessibleCompanies, readSessionUser } from '../accountAccess';
import { expectExactPayload, requestErrorMessage } from '../mutationContract';
import {
  buildActiveRateCodeDetails,
  describeRateRuleAvailability,
} from './accountRateRulePresentation';


export default function UpdateForm({ accessType }) {
  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [accountRateCodeDetail, setAccountRateCodeDetail] = useState([]);
  const [rateCode, setRateCode] = useState("");
  const [rateCode2, setRateCode2] = useState("");
  const [updateFlag, setUpdateFlag] = useState(false);
  const [rateRules1Detail, setRateRules1Detail] = useState([{}]);
  const [lgShow1, setLgShow1] = useState(false);
  const [existingRateRules, setExistingRateRules] = useState([]);
  const [rateRuleValue, setRateRuleValue] = useState("");
  const [rateRuleCurrencyPercent, setRateRuleCurrencyPercent] = useState("%");
  const [rateRuleType, setRateRuleType] = useState("");
  const [rateRule2Detail, setRateRule2Detail] = useState([{}]);
  const [updateClicked, setUpdateClicked] = useState(false);
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
  const [rateRuleMutationPending, setRateRuleMutationPending] = useState(false);
  const [activeRateCodeIds, setActiveRateCodeIds] = useState([]);
  const [rateCodeCatalogCount, setRateCodeCatalogCount] = useState(0);
  const [rateCodeLoading, setRateCodeLoading] = useState(false);
  const [rateCodeSetupLoaded, setRateCodeSetupLoaded] = useState(false);
  const [rateCodeLoadError, setRateCodeLoadError] = useState("");
  const [dependentOptionsLoading, setDependentOptionsLoading] = useState(false);
  const [dependentOptionsError, setDependentOptionsError] = useState("");

  const [hashRateIDVsName, setHashRateIDVsName] = useState({})

  const [dependentOptionArr, setDependentOptionArr] = useState([]);
  const [selectedDependentOption, setSelectedDependentOption] = useState("")

  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  //API call
  useEffect(() => {
    const { user, error } = readSessionUser();

    if (error) {
      setLoggedInUserDetail({});
      setcompanyDetail([]);
      return;
    }

    setLoggedInUserDetail(user);
    loadAccessibleCompanies(baseURL, user, 'AccountRateRules_Account Access')
      .then(setcompanyDetail)
      .catch(() => setcompanyDetail([]));
  }, []);

  //Trigger on Company Name Dropdown Changes , getting Company ID
  useEffect(() => {
    let isCurrentSelection = true;
    setAccountRateCodeDetail([]);
    setActiveRateCodeIds([]);
    setRateCodeCatalogCount(0);
    setRateCodeSetupLoaded(false);
    setHashRateIDVsName({});
    setRateCode("");
    setRateCode2("");
    setRateRules1Detail([]);
    setRateRule2Detail([]);
    setExistingRateRules([]);
    setDependentOptionArr([]);
    setSelectedDependentOption("");
    setDependentOptionsError("");
    setRateCodeLoadError("");
    setcompany_id("");

    if (!Array.isArray(companyDetail) || !companyName) {
      return () => {
        isCurrentSelection = false;
      };
    }

    const selectedCompany = companyDetail.find(
      (value) => value.company_name === companyName
    );
    if (!selectedCompany?._id) {
      setRateCodeLoadError(`The selected account (${companyName}) could not be resolved. Please select it again.`);
      return () => {
        isCurrentSelection = false;
      };
    }

    const company_id_temp = String(selectedCompany._id);
    setcompany_id(company_id_temp);
    setRateCodeLoading(true);

    const companyNumberQuery = "?companyNumber=" + encodeURIComponent(company_id_temp);
    Promise.all([
      axios.get(baseURL + "/get_account_rate_code/" + company_id_temp + companyNumberQuery),
      axios.get(baseURL + "/get_rate_code_setup_for_account/" + company_id_temp + companyNumberQuery),
    ])
      .then(([mappingResponse, catalogResponse]) => {
        if (!isCurrentSelection) return;

        if (!Array.isArray(mappingResponse.data) || !Array.isArray(catalogResponse.data)) {
          throw new Error('The server returned an invalid rate-code response.');
        }

        const activeRateCodes = buildActiveRateCodeDetails(
          mappingResponse.data,
          catalogResponse.data
        );
        setHashRateIDVsName(activeRateCodes.names);
        setRateCodeCatalogCount(catalogResponse.data.length);
        setActiveRateCodeIds(activeRateCodes.activeIds);
        setAccountRateCodeDetail(activeRateCodes.details);
        setExistingRateRules(activeRateCodes.activeIds);
        setRateCodeSetupLoaded(true);
        setUpdateFlag((flag) => !flag);
      })
      .catch((error) => {
        if (!isCurrentSelection) return;
        setRateCodeLoadError(requestErrorMessage(
          error,
          `Rate codes for ${companyName} could not be loaded. Please try again.`
        ));
      })
      .finally(() => {
        if (isCurrentSelection) setRateCodeLoading(false);
      });

    return () => {
      isCurrentSelection = false;
    };
  }, [companyName, companyDetail]);

  //Option for company name
  const companyNameOptions = companyDetail.map((value) => (

    { value: value.company_name, label: value.company_name }
  ));

  const handleInputChangeCompanyName = characterEntered => {
    setCompanyName(characterEntered.value);
  };
  //Option for Rate Code
  const RateCodesOptions = accountRateCodeDetail.map((value) => (

    { value: value.rate_id, label: value.name }
  ));

  const handleInputChangeRateCodes = characterEntered => {
    setRateCode(characterEntered.value);
  };
  //Option for Rate Code
  const RateCodesOptions2 = existingRateRules.map((value) => (

    { value: value, label: value }
  ));

  const handleInputChangeRateCodes2 = characterEntered => {
    setRateCode2(characterEntered.value);
  };

  const rateRuleAvailability = describeRateRuleAvailability({
    companyName,
    rateCodeNames: hashRateIDVsName,
    activeRateCodeIds,
    baseRateCodeId: rateCode,
    availableRateCodeIds: existingRateRules,
  });

  const handleOpenAddRule = () => {
    if (rateCodeLoading) {
      Swal.fire({
        icon: 'info',
        title: 'Rate codes are still loading',
        text: `Please wait while the rate-code setup for ${companyName || 'this account'} is loaded.`,
      });
      return;
    }

    if (rateCodeLoadError) {
      Swal.fire({
        icon: 'error',
        title: 'Rate codes could not be loaded',
        text: rateCodeLoadError,
      });
      return;
    }

    if (!rateRuleAvailability.canAdd) {
      Swal.fire({
        icon: 'info',
        title: rateRuleAvailability.title,
        text: rateRuleAvailability.message,
      });
      return;
    }

    setLgShow1(true);
  };


  //On Submit of Account + RateCodes
  const submitHandler = (e) => {

    e.preventDefault();
    if (rateRuleMutationPending) return;

    if (companyName === "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (rateCode === "") {
      Swal.fire('Please select rate code');
      return;
    }


    Swal.fire({
      title: 'Is this the correct Base Rate Code for this account ?',
      text: 'NOTE: You can not change this once submitted',
      showCancelButton: true,
      confirmButtonText: 'Yes',


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        let existing_rate_rules_arr = [];
        existing_rate_rules_arr = [...existingRateRules];
        const index = existing_rate_rules_arr.indexOf(rateCode);
        if (index > -1) {
          existing_rate_rules_arr.splice(index, 1); // 2nd parameter means remove one item only
        }

        const arr_json_mapping = {
          "_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "account_id": company_id.toString(),
          "selected_base_rate": rateCode,
          "existing_rate_rules": existing_rate_rules_arr,
          "created_date": new Date(),
          "updated_date": new Date(),
          'created_by': loggedInUserDetail.userEmail,
          'updated_by': loggedInUserDetail.userEmail,
        }
        setRateRuleMutationPending(true);
        axios.post(baseURL + "/save_account_rate_rule_1", arr_json_mapping)
          .then((res) => {
            expectExactPayload(res.data, 'success', 'Base Rate Rule save');

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Submitted successfully !!',
              showConfirmButton: false,
              timer: 3000
            })
            setExistingRateRules(existing_rate_rules_arr);
            setUpdateFlag((flag) => !flag);
          })
          .catch((error) => {
            console.error('Unable to save Base Rate Rule:', error);
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Base Rate Rule save failed',
              text: requestErrorMessage(error, 'Unable to save Base Rate Rule. Please try again.'),
            });
          })
          .finally(() => setRateRuleMutationPending(false));
      } else {
        Swal.fire('Changes are not saved');
      }
    });


  }//submitHandler ends here


  //On Submit of Rate Rule
  const handleRateRuleSubmit = (e) => {


    e.preventDefault();
    if (rateRuleMutationPending) return;

    if (companyName === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an account to proceed ahead',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateCode2 === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select rate code',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateRuleType === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please choose type',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateRuleValue === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please enter some value',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateRuleCurrencyPercent === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please choose % or $ option',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }

    if (selectedDependentOption === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please choose dependent on option',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }

    Swal.fire({
      title: 'Do you want to add this Rate Rule ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        let existing_rate_rules_arr = [...existingRateRules];
        const index = existing_rate_rules_arr.indexOf(rateCode2);
        if (index > -1) {
          existing_rate_rules_arr.splice(index, 1); // 2nd parameter means remove one item only
        }
        const index2 = existing_rate_rules_arr.indexOf(rateCode);
        if (index2 > -1) {
          existing_rate_rules_arr.splice(index2, 1); // 2nd parameter means remove one item only
        }

        const arr_json_mapping = {
          "companyNumber": company_id.toString(),
          "existing_rate_rules": existing_rate_rules_arr,
          "updated_date": new Date(),
          'updated_by': loggedInUserDetail.userEmail,
        }
        setRateRuleMutationPending(true);
        axios.put(baseURL + "/update_account_rate_rule_1/" + company_id.toString() + "?companyNumber=" + encodeURIComponent(company_id), arr_json_mapping)
          .then((res) => {
            expectExactPayload(res.data, 'success', 'Base Rate Rule update');
            const arr_json_mapping2 = {
              "_id": company_id.toString() + "-" + rateCode + "-" + rateCode2,
              "companyNumber": company_id.toString(),
              "account_id": company_id.toString(),
              "rate_rule_code": rateCode2,
              "base_rate": selectedDependentOption,
              "type": rateRuleType,
              "value": rateRuleValue,
              "percent_currency": rateRuleCurrencyPercent,
              "created_date": new Date(),
              "updated_date": new Date(),
              'created_by': loggedInUserDetail.userEmail,
              'updated_by': loggedInUserDetail.userEmail,
            };
            return axios.post(baseURL + "/save_account_rate_rule_2", arr_json_mapping2);
          })
          .then((res) => {
            expectExactPayload(res.data, 'success', 'Dependent Rate Rule save');

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Saved Successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setExistingRateRules(existing_rate_rules_arr);
            setUpdateFlag((flag) => !flag);
            setLgShow1(false);
            setRateCode2("");
            setRateRuleCurrencyPercent("");
            setRateRuleType("");
            setRateRuleValue("");
          })
          .catch((error) => {
            console.error('Unable to save Dependent Rate Rule:', error);
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Rate Rule save failed',
              text: requestErrorMessage(error, 'Unable to save Rate Rule. Please try again.'),
            });
          })
          .finally(() => setRateRuleMutationPending(false));

      } else {
        Swal.fire('Changes are not saved');
      }
    });


  }//Rate Rule submitHandler ends here



  useEffect(() => {
    if (!company_id || !rateCodeSetupLoaded) {
      return undefined;
    }

    let isCurrentSelection = true;
    const companyNumberQuery = "?companyNumber=" + encodeURIComponent(company_id);

    Promise.all([
      axios.get(baseURL + "/get_account_rate_rule_1/" + company_id + companyNumberQuery),
      axios.get(baseURL + "/get_account_rate_rule_2/" + company_id + companyNumberQuery),
    ])
      .then(([baseRuleResponse, dependentRulesResponse]) => {
        if (!isCurrentSelection) return;
        if (!Array.isArray(baseRuleResponse.data) || !Array.isArray(dependentRulesResponse.data)) {
          throw new Error('The server returned an invalid Account Rate Rules response.');
        }

        const baseRule = baseRuleResponse.data[0];
        const dependentRules = dependentRulesResponse.data;
        setRateRules1Detail(baseRule ? [baseRule] : []);
        setRateRule2Detail(dependentRules);

        if (!baseRule) {
          setRateCode("");
          setExistingRateRules(activeRateCodeIds);
          return;
        }

        const selectedBaseRate = String(baseRule.selected_base_rate || '');
        const usedRateCodes = new Set(
          dependentRules.map((rule) => String(rule?.rate_rule_code || '')).filter(Boolean)
        );
        const availableRateCodes = activeRateCodeIds.filter((activeRateCodeId) => (
          activeRateCodeId !== selectedBaseRate && !usedRateCodes.has(activeRateCodeId)
        ));

        setRateCode(selectedBaseRate);
        setExistingRateRules(availableRateCodes);
        setRateCodeLoadError("");
      })
      .catch((error) => {
        if (!isCurrentSelection) return;
        setRateCodeLoadError(requestErrorMessage(
          error,
          `Rate rules for ${companyName} could not be loaded. Please try again.`
        ));
      });

    return () => {
      isCurrentSelection = false;
    };
  }, [updateFlag, company_id, rateCodeSetupLoaded, activeRateCodeIds, companyName]);


  const deleteAccountRateCodes = (val_1) => {
    if (rateRuleMutationPending) return;

    Swal.fire({
      title: 'Do you want to delete this Rate Rule ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        setRateRuleMutationPending(true);
        axios.get(baseURL + "/get_account_rate_code/" + company_id + "?companyNumber=" + encodeURIComponent(company_id))
          .then((res) => {

            const active_rate_code_temp = res.data[0].active_rate_codes;

            let existing_rate_rules_arr = [...existingRateRules];

            if (active_rate_code_temp.indexOf(val_1.rate_rule_code) > -1
              && existing_rate_rules_arr.indexOf(val_1.rate_rule_code) < 0) {
              existing_rate_rules_arr.push(val_1.rate_rule_code)
            }
            const arr_json_mapping = {
              "companyNumber": company_id.toString(),
              "existing_rate_rules": existing_rate_rules_arr,
              "updated_date": new Date(),
              'updated_by': loggedInUserDetail.userEmail,
            }
            return axios.put(baseURL + "/update_account_rate_rule_1/" + company_id.toString() + "?companyNumber=" + encodeURIComponent(company_id), arr_json_mapping)
              .then((res) => {
                expectExactPayload(res.data, 'success', 'Base Rate Rule update');
                return axios.post(baseURL + "/delete_account_rate_rule_2?companyNumber=" + encodeURIComponent(company_id), {
                  '_id': val_1._id,
                  'companyNumber': company_id.toString(),
                  "updated_date": new Date(),
                  'updated_by': loggedInUserDetail.userEmail,
                });
              })
              .then((res1) => {
                expectExactPayload(res1.data, 'success', 'Dependent Rate Rule delete');
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Deleted Successfully',
                  showConfirmButton: false,
                  timer: 3000
                });
                setExistingRateRules(existing_rate_rules_arr);
                setUpdateFlag((flag) => !flag);
              });
          })
          .catch((error) => {
            console.error('Unable to delete Rate Rule:', error);
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Rate Rule delete failed',
              text: requestErrorMessage(error, 'Unable to delete Rate Rule. Please try again.'),
            });
          })
          .finally(() => setRateRuleMutationPending(false));

      }
    })
  }


  const handleUpdate = (e) => {

    e.preventDefault();
    if (rateRuleMutationPending) return;

    if (companyName === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an account to proceed ahead',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateCode2 === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select rate code',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateRuleType === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please choose type',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateRuleValue === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please enter some value',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (rateRuleCurrencyPercent === "") {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please choose % or $ option',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    if (selectedDependentOption === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please choose dependent on option',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }


    Swal.fire({
      title: 'Do you want to save these changes ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        const id = company_id + "-" + rateCode + "-" + rateCode2;
        const arr_json_mapping = {
          "companyNumber": company_id.toString(),
          "type": rateRuleType,
          "value": rateRuleValue,
          "percent_currency": rateRuleCurrencyPercent,
          "updated_date": new Date(),
          'updated_by': loggedInUserDetail.userEmail,
        }
        setRateRuleMutationPending(true);
        axios.put(baseURL + "/update_account_rate_rule_2/" + id + "?companyNumber=" + encodeURIComponent(company_id), arr_json_mapping)
          .then((res) => {
            expectExactPayload(res.data, 'success', 'Dependent Rate Rule update');

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Updated Successfully',
              showConfirmButton: false,
              timer: 3000
            })

            setLgShow1(false);
            setUpdateFlag((flag) => !flag);
            setUpdateClicked(false);
            setRateCode2("");
            setRateRuleType("");
            setRateRuleValue("");
            setRateRuleCurrencyPercent("");

          }).catch((error) => {
            console.error('Unable to update Rate Rule:', error);
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Rate Rule update failed',
              text: requestErrorMessage(error, 'Unable to update Rate Rule. Please try again.'),
            });
          })
          .finally(() => setRateRuleMutationPending(false));
      }
    })

  }//update rate rules ends


  const updateAccountRateCodes = (val) => {

    setRateCode2(val.rate_rule_code);
    setRateRuleType(val.type);
    setRateRuleValue(val.value);
    setRateRuleCurrencyPercent(val.percent_currency);
    setSelectedDependentOption(val.base_rate);

    setLgShow1(true);
    setUpdateClicked(true);

  }


  useEffect(() => {

    if (lgShow1 === false) {
      setUpdateClicked(false);
    }
    if (updateClicked === false) {
      setRateCode2("");
      setRateRuleType("");
      setRateRuleValue("");
      setRateRuleCurrencyPercent("");
      setSelectedDependentOption("");
      setDependentOptionArr([]);
    }
  }, [lgShow1])


  useEffect(() => {
    if (rateRuleType === 'Decreased By') {

      setRateRuleCurrencyPercent('%');
    }

  }, [rateRuleType])


  //Validation for only number allowed 
  useEffect(() => {
    if (rateRuleValue !== "") {
      if (isNaN(rateRuleValue) || rateRuleValue < 0) {
        Swal.fire({
        position: 'center',
          icon: 'error',
          title: 'Only positive numbers allowed',
          showConfirmButton: false,
          timer: 3000
        })

        setRateRuleValue("")
      }
    }
  }, [rateRuleValue])



  const handleDependentOptions = async (rate_code) => {
    setDependentOptionArr([]);
    setSelectedDependentOption("");
    setDependentOptionsError("");
    if (!rate_code) return;

    setDependentOptionsLoading(true);
    try {
      const response = await axios.post(baseURL + "/get_rate_code_dependent_options", {
        'companyNumber': company_id.toString(),
        'dependie_chosen': rate_code,
        'base_rate': rateCode,
        'account_id': company_id
      });
      if (!Array.isArray(response.data)) {
        throw new Error('The server returned an invalid base-rate-code response.');
      }

      const validOptions = [...new Set(
        response.data.map((value) => String(value || '').trim()).filter(Boolean)
      )];
      setDependentOptionArr(validOptions);
      if (validOptions.length === 1) {
        setSelectedDependentOption(validOptions[0]);
      } else if (validOptions.length === 0) {
        setDependentOptionsError(
          `No valid base rate code is available for ${hashRateIDVsName[rate_code] || rate_code}.`
        );
      }
    } catch (error) {
      const message = requestErrorMessage(
        error,
        'Valid base rate codes could not be loaded. Please try again.'
      );
      setDependentOptionsError(message);
      Swal.fire({
        icon: 'error',
        title: 'Base rate codes could not be loaded',
        text: message,
      });
    } finally {
      setDependentOptionsLoading(false);
    }
  }


  return (
    <>
      <div className="row pt-2" ref={titleRef}>
        <div className="col-8 mx-3">
          <span style={{ color: '#1E1E1E', fontSize: '21px' }}>

            {accessType === 'View' ? "Select account to view Rate Rules: " : "Select account for Rate Rules: "}
          </span>
        </div>
      </div>

      <div className="row pt-5">
        {/* <div className="col-1"></div> */}
        <div className="col-10 mx-3">
          {/* First Row */}
          <div className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="company_name" className="form-label">
                Account Name
              </label>
            </div>

            <div className="col-md-4 mb-3">


              <Select

                value={{ value: companyName, label: (companyName ? companyName : "Select Account Name") }}
                inputId="company_name"
                name="company_name"
                options={companyNameOptions}
                onChange={handleInputChangeCompanyName}

              />

            </div>


            <div className="col-md-1 mb-3"></div>

            <div className="col-md-2 mb-3">
              {/* <label htmlFor="company_id" className="form-label">
                Account ID
              </label> */}
            </div>
            <div className="col-md-2 mb-3">
              {/* <input
                type="text"
                className="form-control"
                value={company_id}
                id="company_id"
                disabled
              /> */}
            </div>

          </div>{/* first row wrapper ends */}
          {rateCodeLoading && (
            <div className="alert alert-info py-2" role="status">
              Loading active rate codes for {companyName}...
            </div>
          )}
          {rateCodeLoadError && (
            <div className="alert alert-danger" role="alert">
              <strong>Account Rate Rules could not be loaded.</strong> {rateCodeLoadError}
            </div>
          )}
          {/* Second Row */}

          <div className="row mt-3">
            <div className="col-md-2 mb-3">
              <label htmlFor="rate_code" className="form-label">
                {rateRules1Detail.length > 0 ? 'Base Rate Code' : 'Select Base Rate Code'}
              </label>
            </div>

            <div className="col-md-4 mb-3">

              {rateRules1Detail.length > 0 ?
                (
                  <input
                    type="text"
                    className="form-control"
                    value={hashRateIDVsName[rateCode] || rateCode}
                    id="rate_code"
                    disabled
                  />
                )

                :
                // (<Select

                //   value={{ value: rateCode, label: (rateCode ? rateCode : "Select Rate Code") }}
                //   inputId="rate_code"
                //   name="rate_code"
                //   options={RateCodesOptions}
                //   onChange={handleInputChangeRateCodes}
                //   isDisabled={accessType === 'View'}
                // />)

                (<select className="form-select" aria-label="Select base rate code" onChange={(e) => setRateCode(e.target.value)} value={rateCode} disabled={rateCodeLoading || accountRateCodeDetail.length === 0}>
                  <option value="">{accountRateCodeDetail.length === 0 ? 'No active rate codes available' : 'Select one'}</option>
                  {accountRateCodeDetail.length > 0 && accountRateCodeDetail.map((val) => (

                    <option key={val.rate_id} value={val.rate_id}>{hashRateIDVsName[val.rate_id]}</option>
                  ))
                  }
                </select>
                )

              }

            </div>
            <div className="col-md-1 mb-3"></div>
            <div className="col-md-2 mb-3">

            </div>
            <div className="col-md-2 mb-3">
              {accessType === 'View' || rateRules1Detail.length > 0 ? "" : (
                <button type="submit" className="btn btn-success" onClick={(e) => submitHandler(e)} disabled={rateRuleMutationPending}>
                  {rateRuleMutationPending ? 'Saving...' : 'Submit'}
                </button>

              )}

            </div>

            <div className="col-md-5 mb-3"></div>

          </div>{/* second row wrapper ends */}

          {/* Third row */}
          <div className="row mt-3">
            <div className="col-12 mb-4 d-flex justify-content-start">

              {!(accessType === 'View') && rateRules1Detail.length > 0 && companyName ? (
                <button type="button" className="btn btn-success" onClick={handleOpenAddRule}>
                  Add New Rule
                </button>
              ) : ""}

              <Modal
                size="lg"
                show={lgShow1}
                onHide={() => setLgShow1(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                dialogClassName="modal-90w"
              >
                <Modal.Header closeButton >
                  <Modal.Title id="example-modal-sizes-title-lg" >
                    {updateClicked ? "Edit Rate Rule" : "Add New Rate Rule"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  <form >

                    <table className="table table-borderless">

                      <thead>
                        <tr>

                          <th scope="col">Select Rate Code</th>
                          <th scope="col">Depends On / Base Rate Code</th>
                          <th scope="col">Type</th>
                          <th scope="col">Value</th>
                          <th scope="col">% {rateRuleType !== 'Decreased By' && '/ $'}</th>


                        </tr>
                      </thead>
                      <tbody>

                        <tr>
                          <td>

                            {updateClicked ? (
                              <input
                                type="text"
                                className="form-control"
                                value={hashRateIDVsName[rateCode2]}
                                id="base_rate"
                                disabled
                              />
                            ) : (
                              // <Select

                              //   value={{ value: rateCode2, label: (rateCode2 ? rateCode2 : "Select Rate Code") }}
                              //   inputId="rate_code"
                              //   name="rate_code"
                              //   options={RateCodesOptions2}
                              //   onChange={handleInputChangeRateCodes2}

                              // />
                              <select className="form-select" aria-label="Select rate code"
                                onChange={(e) => { setRateCode2(e.target.value); handleDependentOptions(e.target.value); }}
                                value={rateCode2}
                                disabled={rateRuleMutationPending || existingRateRules.length === 0}>
                                <option value="">{existingRateRules.length === 0 ? 'No unused active rate codes' : 'Select rate code'}</option>
                                {existingRateRules.length > 0 && existingRateRules.map((val) => (

                                  <option key={val} value={val}>{hashRateIDVsName[val] || val}</option>
                                ))
                                }
                              </select>

                            )}

                          </td>
                          <td>
                            {!updateClicked ?
                              <select className="form-select" aria-label="Select dependency base rate code"
                                onChange={(e) => { setSelectedDependentOption(e.target.value) }}
                                value={selectedDependentOption}
                                disabled={!rateCode2 || dependentOptionsLoading || dependentOptionArr.length === 0}>
                                <option value="">{
                                  dependentOptionsLoading
                                    ? 'Loading base rate codes...'
                                    : !rateCode2
                                      ? 'Select a rate code first'
                                      : dependentOptionArr.length === 0
                                        ? 'No valid base rate codes'
                                        : 'Select base rate code'
                                }</option>
                                {dependentOptionArr.length > 0 && dependentOptionArr.map((val) => (

                                  <option key={val} value={val}>{hashRateIDVsName[val] || val}</option>
                                ))
                                }
                              </select>
                              :
                              <input
                                type="text"
                                className="form-control"
                                value={hashRateIDVsName[selectedDependentOption]}
                                onChange=""
                                id="base_rate"
                                disabled
                              />
                            }
                            {dependentOptionsError && (
                              <small className="text-danger d-block mt-1">{dependentOptionsError}</small>
                            )}
                          </td>
                          <td>
                            <select className="form-select" value={rateRuleType} onChange={(e) => setRateRuleType(e.target.value)}>
                              <option hidden>Choose</option>
                              <option value="Increased By">Increased By</option>
                              <option value="Decreased By">Decreased By</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              onChange={(e) => setRateRuleValue(e.target.value)}
                              id="rate_rule_value"
                              value={rateRuleValue}
                            />
                          </td>
                          <td>
                            <select className="form-select" value={rateRuleCurrencyPercent} onChange={(e) => setRateRuleCurrencyPercent(e.target.value)}>
                              <option hidden>Choose</option>
                              <option value="%">%</option>
                              {rateRuleType !== 'Decreased By' && <option value="$">$</option>}
                            </select>
                            {/* <input
                              type="text"
                              className="form-control"
                              id="rate_rule_percent"
                              value={"%"}
                              disabled
                            /> */}
                          </td>

                        </tr>

                      </tbody>
                    </table>

                    <div className="row pt-2">
                      <div className="col-5 d-flex-wrap"></div>
                      {updateClicked ? (

                        <>

                          <div className="col-7 d-flex justify-content-end">

                            <button className="btn btn-success" onClick={(e) => handleUpdate(e)} disabled={rateRuleMutationPending}>
                              {rateRuleMutationPending ? 'Updating...' : 'Update'}
                            </button>
                          </div>

                        </>

                      ) : (
                        <>

                          <div className="col-7 d-flex justify-content-end">

                            <button className="btn btn-success" onClick={(e) => handleRateRuleSubmit(e)} disabled={rateRuleMutationPending}>
                              {rateRuleMutationPending ? 'Saving...' : 'Save'}
                            </button>
                          </div>

                        </>
                      )}
                    </div>
                  </form>


                </Modal.Body>
              </Modal>
            </div>
          </div>{/* Third row wrapper ends */}

          {rateRules1Detail.length > 0 && companyName && !rateCodeLoading && !rateCodeLoadError && (
            <div className="row">
              <div className="col-12">
                <div
                  className={`alert ${rateRuleAvailability.canAdd ? 'alert-info' : 'alert-warning'}`}
                  role="status"
                >
                  <strong>Rate-code availability:</strong>{' '}
                  {rateCodeCatalogCount} configured, {activeRateCodeIds.length} active, and{' '}
                  {existingRateRules.length} available for a new rule.
                  {!rateRuleAvailability.canAdd && (
                    <div className="mt-1">
                      <strong>{rateRuleAvailability.title}.</strong>{' '}
                      {rateRuleAvailability.message}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Fourth Row*/}
          <div className="row mt-3">
            <div className="col-12">
              <h5 className="mb-3">Existing Records: </h5>
              <div
                className="mvp-table-scroll mvp-table-scroll--wide"
                role="region"
                aria-label="Existing account rate rules"
                tabIndex="0"
              >
              <table className="table" >
                <thead>
                  <tr>
                    <th scope="col">Base Rate Code</th>
                    <th scope="col">Rate Code</th>
                    <th scope="col">Increased By / Decreased By</th>
                    <th scope="col">Value</th>
                    <th scope="col">% / $ </th>
                    <th scope="col">Last Updated By</th>
                    <th scope="col">Last Updated Date</th>
                    {
                      !(accessType === 'View') && <>
                        <th scope="col">Edit</th>
                        <th scope="col">Delete</th>
                      </>
                    }
                  </tr>
                </thead>
                <tbody>

                  {
                    rateCode !== "" ? rateRule2Detail.map((val, i) => (
                      <tr>
                        <td>{hashRateIDVsName[val.base_rate]}</td>
                        <td>{hashRateIDVsName[val.rate_rule_code]}</td>
                        <td>{val.type}</td>
                        <td>{val.value}</td>
                        <td>{val.percent_currency}</td>
                        <td>{val.updated_by}</td>
                        <td>{formatDate_withTime(new Date(val.updated_date))}</td>
                        {
                          !(accessType === 'View') && <>
                            <td><button type="button" className="mvp-table-icon-action" aria-label="Edit account rate rule" onClick={() => updateAccountRateCodes(val)}><EditIcon /></button></td>
                            <td><button type="button" className="mvp-table-icon-action mvp-table-icon-action--danger" aria-label="Delete account rate rule" onClick={() => deleteAccountRateCodes(val)}><DeleteForeverIcon /></button></td>
                          </>}
                      </tr>

                    )) : ""
                  }

                </tbody>
              </table>
              </div>
            </div>
          </div>{/* Fourth row ends */}

          <div className="col-md-10 mb-4 ">

          </div>



        </div>


      </div> {/* overall wrapper row ends */}

    </>
  );
}
